import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/team-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-7806601e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "100",
  height: "30",
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("トップ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr5" }, " プロジェクト ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Login ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("プロジェクト設定")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("タレント設定")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("ユーザ設定")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("チーム異常検知(β)")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Logout")

import { useStore } from "vuex";
import { reactive } from "vue";
import { onMounted, ref, computed } from "vue";
import { watch } from "vue";
import { useRouter } from "vue-router";
import ProjectPopover from "@/components/header/ProjectPopover.vue";
import { UserRepository } from '@/repositories/UserRepository'
import { Setting } from '@element-plus/icons';
import webpush from '@/utils/ServiceWorkerRegister.js'
import { NoticeState } from "@/state/NoticeState";
import { ChatDotRound } from '@element-plus/icons';
import { Project } from "@/types/project";
import { SelectCategoryState } from '@/state/SelectCategoryState'

type ProjectListPopover = {
  projects: Project[];
  visible: boolean;
  handleLinkClick: Function
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeIndex = ref("1")
const store = useStore();
const router = useRouter();
const login_status = computed(() => store.state.login.login_status);
const managerFlg =  computed(() => store.state.login.manager_flg);
const logout = () => {
  store.dispatch("login/logout", {}).then(
    () => {
      router.push("/login");
    },
    (error) => {
      console.log(error);
      // error_message.value = "ログインに失敗しました";
    }
  );
  SelectCategoryState.clear();
};

const projectListPopover = reactive<ProjectListPopover>({
  projects: [],
  visible: false,
  handleLinkClick: () => {
    projectListPopover.visible = false;
    activeIndex.value = '6'
  },
});

const repository = new UserRepository();
onMounted(async () => {
  if (!store.state.login.login_status) {
    return;
  }
  try {
    projectListPopover.projects = await repository.getProjects(store.state.login.user_id);
  } catch (e) {
    console.log(e);
  }
  webpush.setPushService();
});
watch(() => store.state.login.login_status, async (isLogin) => {
  if (isLogin) {
    projectListPopover.projects = await repository.getProjects(store.state.login.user_id);
  } else {
    projectListPopover.projects = [];
  }
});


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "active-text-color": "#fff",
    "background-color": "#EA5242",
    "text-color": "#fff",
    "default-active": activeIndex.value,
    class: "custom-class",
    mode: "horizontal",
    "menu-trigger": "click",
    router: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, {
        index: "0",
        route: {}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_menu_item, {
        index: "1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeIndex.value = '1')),
        route: { path: '/' }
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 512), [
        [_vShow, _unref(login_status)]
      ]),
      _withDirectives(_createVNode(_component_el_menu_item, {
        index: "6",
        route: {},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(projectListPopover).visible = !_unref(projectListPopover).visible))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_popover, {
            placement: "bottom",
            trigger: "click",
            width: 500,
            offset: 30,
            visible: _unref(projectListPopover).visible,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(projectListPopover).visible) = $event)),
            transition: "",
            "show-arrow": false
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, { type: "text" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_el_badge, {
                    "is-dot": "",
                    type: "primary",
                    hidden: _unref(NoticeState).otherNotice(Number(_ctx.$route.params.project_id)) == false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChatDotRound))
                    ]),
                    _: 1
                  }, 8, ["hidden"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(ProjectPopover, {
                projects: _unref(projectListPopover).projects,
                onOnClick: _unref(projectListPopover).handleLinkClick
              }, null, 8, ["projects", "onOnClick"])
            ]),
            _: 1
          }, 8, ["visible"])
        ]),
        _: 1
      }, 512), [
        [_vShow, _unref(login_status)]
      ]),
      _withDirectives(_createVNode(_component_el_menu_item, {
        index: "8",
        route: { path: '/login' },
        style: { marginLeft: 'auto' }
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 512), [
        [_vShow, !_unref(login_status)]
      ]),
      (_unref(login_status))
        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: "setting",
            style: { marginLeft: 'auto' }
          }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, {
                size: 19,
                style: { verticalAlign: 'baseline' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Setting))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              (_unref(managerFlg))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    index: "setting:projects",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (activeIndex.value = 'setting:projects')),
                    route: { path: '/projects' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(managerFlg))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: "setting:users",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (activeIndex.value = 'setting:users')),
                    route: { path: '/users' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_menu_item, {
                index: "setting:user_setting",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (activeIndex.value = 'setting:user_setting')),
                route: { path: '/user_setting' }
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              (_unref(managerFlg))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 2,
                    index: "setting:alert_forms",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (activeIndex.value = 'setting:alert_forms')),
                    route: { path: '/alert_forms' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_menu_item, {
                index: "setting:logout",
                route: {},
                onClick: logout
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})